<mat-form-field appearance="outline">
    <mat-label *ngIf="easControl.field.widget.showInlineLabel">{{ easControl.field.title }}</mat-label>
    <mat-chip-grid #chipGrid aria-label="Selection">
        @for (category of selectedCategories(); track $index) {
          <mat-chip-row (removed)="remove(category)">
            {{category.name}}
            <button matChipRemove [attr.aria-label]="'remove ' + category">
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip-row>
        }
    </mat-chip-grid>

    <input #input
        (input)="filter()"
        (focus)="filter()"
        type="text"
        [placeholder]="easControl.field.widget?.placeholder ?? ''"
        matInput
        [matChipInputFor]="chipGrid"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matAutocomplete]="auto">


    <mat-autocomplete  #auto="matAutocomplete" (optionSelected)="selected($event)">
      <mat-option *ngIf="$isLoading()" class="is-loading" i18n>Loading...</mat-option>
      <mat-option *ngIf="errorMsg" class="error">{{ errorMsg }}</mat-option>
      <ng-container *ngIf="!$isLoading()">
        <mat-option *ngFor="let option of categories$ | async" [value]="option">
          {{option.name}}
        </mat-option>
      </ng-container>
    </mat-autocomplete>
  <mat-error *ngIf="this.easControl.control.errors">{{currentErrors}}</mat-error>
</mat-form-field>
